export class CommercialUploadHttpError extends Error {
  constructor(readonly status: number, readonly code?: string) {
    super("Commercial document upload failed");
    this.name = "CommercialUploadHttpError";
  }
}

export class CommercialUploadClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CommercialUploadClientError";
  }
}

export async function commercialUploadHttpError(response: Pick<Response, "status" | "json">) {
  const body = await response.json().catch(() => null) as { error?: unknown } | null;
  const code = typeof body?.error === "string" ? body.error : undefined;
  return new CommercialUploadHttpError(response.status, code);
}

export function commercialUploadErrorMessage(error: unknown): string {
  if (error instanceof CommercialUploadClientError) return error.message;
  if (error instanceof CommercialUploadHttpError) {
    if (error.status === 415 || error.code === "UNSUPPORTED_MEDIA_TYPE") {
      return "Formato no admitido. Elige un archivo PDF o una imagen JPG, PNG o WebP.";
    }
    if (error.status === 413 || error.code === "COMMERCIAL_FILE_SIZE_INVALID") {
      return "El archivo supera el límite de 20 MB. Elige un archivo más pequeño.";
    }
    return "No se pudo subir el archivo. Comprueba el archivo e inténtalo de nuevo.";
  }
  if (error instanceof TypeError) {
    return "No se pudo conectar para subir el archivo. Comprueba la conexión e inténtalo de nuevo.";
  }
  return "No se pudo subir el archivo. Comprueba el archivo e inténtalo de nuevo.";
}

export function commercialUploadPartialMessage(completed: number, total: number, error: unknown): string {
  return `Carga parcial: ${completed}/${total} archivos confirmados. ${commercialUploadErrorMessage(error)} Los archivos guardados se conservan; vuelve a seleccionar para reintentar.`;
}

export function commercialUploadReadbackMessage(total: number, error: unknown): string {
  return `El servidor respondió para ${total}/${total} archivos, pero no se pudo verificar la carga. ${commercialUploadErrorMessage(error)} Los documentos anteriores se conservan.`;
}
